/*
 * @Author: SK-20251129GXNS\Administrator zpx
 * @Date: 2026-01-20 22:07:03
 * @LastEditors: SK-20251129GXNS\Administrator zpx
 * @LastEditTime: 2026-02-04 01:46:04
 * @FilePath: \frontend\src\utils\format.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 格式化数字，保留两位小数，小数点使用逗号
 * @param {number|string} value - 需要格式化的数字
 * @returns {string} 格式化后的字符串
 */
export function formatNumberWithComma(value) {
  if (value === null || value === undefined || value === '') {
    return '0,00'
  }

  const num = Number(value)
  if (isNaN(num)) {
    return '0,00'
  }

  // 保留两位小数
  const fixedNum = num.toFixed(2)
  // 分割整数部分和小数部分
  const [integerPart, decimalPart] = fixedNum.split('.')
  // 对整数部分添加千分位分隔符
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  // 组合整数部分和小数部分，使用逗号作为小数点
  return `${formattedInteger},${decimalPart}`
}

/**
 * 格式化数字为千分位格式，使用点作为分隔符
 * @param {number|string} value - 需要格式化的数字
 * @returns {string} 格式化后的字符串
 */
export function formatNumberWithThousandsSeparator(value) {
  if (value === null || value === undefined || value === '') {
    return '0'
  }

  const num = Number(value)
  if (isNaN(num)) {
    return '0'
  }

  // 使用正则表达式添加千分位分隔符
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
